
<div class="chart-title">
    <div id="chart-text-{{id}}" class="chart-text">{{graphName}}</div>
    <ng-container *ngIf="graphName === 'Top Solution Groups'">
        <div class="chart-legend" id="usage-legend">% of Location Usage</div>
    </ng-container>
    <ng-container *ngIf="graphName === 'Top Field Sales and Opportunity'">
        <div id="top-sales-legend-{{id}}" class="top-sales-legend">
            <div class="chart-legend sales" id="sales-legend">Field Sales</div>
            <div class="chart-legend opportunity" id="opportunity-legend">Opportunity {{currencySymbol}}</div>
        </div>
    </ng-container>
</div>
<div echarts 
    [options]="chartOptions" id="bar-chart-{{id}}">
</div>
<div *ngIf="displayCaretIcon" id="caret-icon-{{id}}" class="caret-icon" [class.expand]="isExpand" (click)="toggleClass()">
    <img *ngIf="graphName === 'Top Solution Groups'" src="/assets/caret-green.svg" alt="expand-collapse-icon"/>
    <img *ngIf="graphName === 'Top Field Sales and Opportunity'" src="/assets/caret-blue.svg" alt="expand-collapse-icon"/>
</div>

